"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var insertedFrames = [];

var _default = function _default(className, style) {
  if (className) {
    if (!insertedFrames.includes(className)) {
      var styleNode = document.createElement('style');
      styleNode.setAttribute('data-meta', "p24c-".concat(className, "-rule"));
      document.querySelector('head').insertBefore(styleNode, document.querySelector('head').firstChild);
      var sheet = [].find.call(document.styleSheets, function (s) {
        return s.ownerNode === styleNode;
      }),
          rule = "\n                    .".concat(className, " {\n                        ").concat(style, "\n                    }\n                ");

      try {
        sheet.insertRule(rule, sheet.cssRules && sheet.cssRules.length);
        insertedFrames.push(className);
      } catch (e) {
        window.console.warn(e);
      }
    }
  } else {
    window.console.warn('className is required to be passed to insert css rule');
  }
};

exports["default"] = _default;